export const API_URL =
  (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";

export const SESSION_KEY = "vhrp_session_token";

let fileToken = null;

export function getToken() {
  const t = localStorage.getItem(SESSION_KEY);
  return t && t !== "" ? t : null;
}

export function setToken(token) {
  if (token) localStorage.setItem(SESSION_KEY, token);
  else {
    fileToken = null;
    localStorage.removeItem(SESSION_KEY);
  }
}

export async function api(path, opts = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...(opts.headers || {}),
  };
  if (!opts.skipAuth) {
    const t = getToken();
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${API_URL}${path}`, { ...opts, headers });
  const text = await res.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  if (!res.ok) {
    const detail = (data && (data.detail || data.error)) || `HTTP ${res.status}`;
    throw new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
  }
  return data;
}

// Upload a File/Blob (web file input) to an upload endpoint.
export async function uploadFile(file, endpoint = "/upload/photo") {
  const t = getToken();
  const form = new FormData();
  form.append("file", file, file.name || "photo.jpg");
  const res = await fetch(`${API_URL}${endpoint}`, {
    method: "POST",
    headers: t ? { Authorization: `Bearer ${t}` } : undefined,
    body: form,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "Upload failed");
  return data;
}

// Build an authed URL for a protected uploaded file (short-lived file-scoped token).
export async function fileUrl(path) {
  if (!path) return null;
  const t = getToken();
  if (!t) return null;
  if (!fileToken || Date.now() > fileToken.exp - 60_000) {
    try {
      const r = await api("/files-token");
      fileToken = { token: r.token, exp: Date.now() + r.expires_in * 1000 };
    } catch {
      return null;
    }
  }
  return `${API_URL}/files/${path}?token=${encodeURIComponent(fileToken.token)}`;
}
